import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, onBeforeUnmount, ref, watch } from 'vue'
import { emitter } from '@/plugins/emitter'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useFormatLocalData } from '@/composables/format-edit/useFormatLocalData'
import {
  createEmptyRirekishoFormatData,
  provideRirekishoFormatData,
  type RirekishoExampleSentences
} from '@/composables/format-edit/useRirekishoFormatData'
import {
  provideRirekishoHistories,
  useRirekishoHistories
} from '@/composables/format-edit/useRirekishoHistories'
import RirekishoEduHistoryCard from '@/components/format-edit/rirekisho/RirekishoEduHistoryCard.vue'
import RirekishoJobHistoryCard from '@/components/format-edit/rirekisho/RirekishoJobHistoryCard.vue'
import RirekishoLicenseCard from '@/components/format-edit/rirekisho/RirekishoLicenseCard.vue'
import RirekishoReasonCard from '@/components/format-edit/rirekisho/RirekishoReasonCard.vue'
import RirekishoAiReasonCard from '@/components/format-edit/rirekisho/RirekishoAiReasonCard.vue'
import RirekishoReasonNewCard from '@/components/format-edit/rirekisho/RirekishoReasonNewCard.vue'
import RirekishoOthersCard from '@/components/format-edit/rirekisho/RirekishoOthersCard.vue'
import RirekishoRequestsCard from '@/components/format-edit/rirekisho/RirekishoRequestsCard.vue'
import RirekishoEsfDetailCard from '@/components/format-edit/rirekisho/RirekishoEsfDetailCard.vue'
import RirekishoRecommendCard from '@/components/format-edit/rirekisho/RirekishoRecommendCard.vue'
import RirekishoCreateDateCard from '@/components/format-edit/rirekisho/RirekishoCreateDateCard.vue'
import DownloadItem from '@/components/formats/CommonParts/DownloadItem.vue'
import type { BasicData } from '@/utils/format-edit/basicData'
import { isCardSectionActive } from '@/utils/format-edit/cardSections'


export default /*#__PURE__*/_defineComponent({
  __name: 'RirekishoEdit',
  props: {
    basicData: null,
    formatId: null,
    previewFormat: null,
    currentCardId: null,
    exampleSentences: null
  },
  emits: ["update-basic-data"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'update-basic-data', payload: Partial<BasicData>): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  basicData: BasicData
  formatId?: string
  previewFormat?: {
    errorMessages?: Record<string, string>
    optionItems?: Record<string, unknown>
  } | null
  currentCardId?: string
  exampleSentences?: RirekishoExampleSentences
};





const { formLib } = useHostServices()

const { formatData } = useFormatLocalData({
  saveName: 'rirekisho',
  saveOtherName: 'shokumukeirekisho',
  createEmpty: createEmptyRirekishoFormatData
})
provideRirekishoFormatData(formatData)

const histories = useRirekishoHistories(formatData)
provideRirekishoHistories(histories)

const mailPdfEnabled = ref(true)
const downloadPdfEnabled = ref(true)
const isSendYagiPostEnabled = ref(true)
const isSendYagiEmailEnabled = ref(true)
const downloadActiveCollapses = ref(['postcard'])

const previewErrors = computed(() => {
  if (!props.previewFormat || !props.previewFormat.errorMessages) return {}
  return props.previewFormat.errorMessages
})

const optionItems = computed(() => {
  if (!props.previewFormat || !props.previewFormat.optionItems) return {}
  return props.previewFormat.optionItems
})

const getMode = computed(() => process.env.VUE_APP_MODE)

// 学歴・職歴が 1 ステップへ統合された書式かどうか（カード定義の `sections`）
const isHistoryMerged = computed(
  () =>
    isCardSectionActive(props.formatId, props.currentCardId, 'edu-history') &&
    isCardSectionActive(props.formatId, props.currentCardId, 'job-history')
)

const textareaMinRows = computed(() => {
  if (props.formatId === 'rirekisho_job_new') return 10
  if (props.formatId === 'rirekisho_job_new_single') return 6
  return 3
})

function dataChanged() {
  mailPdfEnabled.value = true
  downloadPdfEnabled.value = true
}

watch(
  () => formatData.createDate,
  (newValue) => {
    if (newValue == null) return
    formatData.writeDate = formLib.dateFormat(
      newValue as Date,
      'yyyy年 m月 d日'
    )
  }
)

onBeforeMount(() => {
  if (formatData.createDate === null) {
    formatData.createDate = formLib.getToday()
  }
  emitter.on('basic-data-changed', dataChanged)
  emitter.on('format-data-changed', dataChanged)
})

onBeforeUnmount(() => {
  emitter.off('basic-data-changed', dataChanged)
  emitter.off('format-data-changed', dataChanged)
})

expose({
  saveName: 'rirekisho',
  formatData,
  addEducationalHistory: histories.addEducationalHistory
})

return { __sfc: true,props, emit, formLib, formatData, histories, mailPdfEnabled, downloadPdfEnabled, isSendYagiPostEnabled, isSendYagiEmailEnabled, downloadActiveCollapses, previewErrors, optionItems, getMode, isHistoryMerged, textareaMinRows, dataChanged, RirekishoEduHistoryCard, RirekishoJobHistoryCard, RirekishoLicenseCard, RirekishoReasonCard, RirekishoAiReasonCard, RirekishoReasonNewCard, RirekishoOthersCard, RirekishoRequestsCard, RirekishoEsfDetailCard, RirekishoRecommendCard, RirekishoCreateDateCard, DownloadItem }
}

})